import Create from './create/CreateAgreementTemplate';
import Edit from './edit/EditAgreementTemplate';
import Individual from './individual/AgreementTemplate';

export default { Create, Individual, Edit };
